import { BaseEntity, PaginatedEntity, UserEntity } from '@core/entities';
import { Expose, plainToClass, Transform, Type } from 'class-transformer';
import { ApprovedStatus } from '@core/enums';

export class GroupEventsList extends PaginatedEntity {
  @Type(() => GroupEventEntity)
  groupEvents: GroupEventEntity[];
}

export class GroupEventEntity extends BaseEntity {
  schedule: any;
  type: string;

  @Expose()
  @Transform((item) => encodeURIComponent(item.value), { toPlainOnly: true })
  @Transform((item) => decodeURIComponent(item.value), { toClassOnly: true })
  name: string;

  @Expose()
  @Transform((item) => encodeURIComponent(item.value), { toPlainOnly: true })
  @Transform((item) => decodeURIComponent(item.value), { toClassOnly: true })
  description: string;

  author: string;
  // user: UserEntity;
  place: string;
  audience: number;

  @Expose({ name: 'participantCount' })
  participantsCount: number;

  @Expose({ name: 'group_id' })
  groupId: number;

  chargeable: number;

  @Expose({ name: 'price_per_participant' })
  pricePerParticipant: number;

  @Expose({ name: 'allowed_persons' })
  allowedPersons: number;

  @Expose({ name: 'date_from' })
  dateFrom: string;

  @Expose({ name: 'date_to' })
  dateTo: string;

  @Expose({ name: 'date_repeat' })
  dateRepeat: string;

  @Expose({ name: 'recurring_dates' })
  @Transform(({ value }) => plainToClass(RecurringDate, JSON.parse(value) as RecurringDate))
  recurringDates?: RecurringDate[];

  @Expose({ name: 'start_time' })
  startTime: string;

  @Expose({ name: 'end_time' })
  endTime: string;

  @Expose({ name: 'event_images' })
  @Type(() => EventImage)
  eventImages: EventImage[];

  @Type(() => UserEntity)
  user: UserEntity;
}

export class EventImage {
  @Expose({ name: 'event_id' })
  eventId: number;
  @Expose({ name: 'event_image' })
  eventImage: string;
  @Expose({ name: 'event_document' })
  eventDocument: string;
}

export class RecurringDate {
  @Expose({ name: 'date_from' })
  dateFrom: string;
  @Expose({ name: 'date_end' })
  dateEnd?: string;
  @Expose({ name: 'start_time' })
  startTime: string;
  @Expose({ name: 'end_time' })
  endTime: string;
}

export class GroupEventParticipant {
  @Expose({ name: 'users' })
  @Type(() => UserEntity)
  user: UserEntity;

  @Expose({ name: 'approved_status' })
  approvedStatus: ApprovedStatus;
}
